export default {
    text_0: "Feedback",
    text_1: "Nápady a hlášení chyb",
    text_2: "Máš jakýkoli nápad, jak DOFFERO zlepšit nebo co by ti pomohlo? Chceš nahlásit nějakou chybu? Do toho. Nejlepší postřehy odměníme.",
    text_3: "Vyplň, pokud tě můžeme kontaktovat pro více informací.",
    text_4: "Telefonní číslo (nepovinné)",
    text_5: "E-mail (nepovinné)",
    text_6: "Poznatky, postřehy, chyby",
    text_7: "Odeslat",
    text_8: "Je třeba zadat poznatky, postřehy, chyby.",
    text_9: "Feedback byl úspěšně odeslán. Děkujeme.",
    text_10: "Vložte screenshot",
    text_11: "nebo",
    text_12: "Vybrat screenshot",
    text_13: "Smazat",
    text_14: "Stáhnout",
    text_15: "Opravdu chcete smazat soubor?",
    text_16: "Je možné nahrát jen 1 soubor.",
    text_17: "Pouze {extensions} soubory mohou být nahrány.",
    text_18: "{name} je příliš velký! Prosím, vyberte soubor do velikosti {fileMaxSize} MB.",

}
